import { SkeletonMotion } from '@acp/core-ui';
import {
    Center, HStack, SkeletonCircle, VStack,
} from '@chakra-ui/react';

export function BarChartSkeleton() {
    return (
        <VStack w="full" h={96}>
            <Center mt={10}>
                <VStack
                    h="inherit"
                    w={250}
                    gap={8}
                    flexWrap={{ base: 'wrap', lg: 'nowrap' }}
                    transform={{ base: 'rotate(90deg)' }}
                    alignItems="flex-end"
                >
                    <SkeletonMotion h={8} />
                    <SkeletonMotion h={8} />
                    <SkeletonMotion h={8} />
                    <SkeletonMotion h={8} />
                </VStack>
            </Center>
        </VStack>
    );
}

export function PortfolioGraphSkeleton() {
    return (
        <VStack w="full" h={96}>
            <HStack
                w="full"
                h="full"
                justifyContent="center"
                alignItems="center"
            >
                <SkeletonCircle size="200" />
            </HStack>
        </VStack>
    );
}
